import * as angular from 'angular';
import template from './configSelector.tpl.html';
import AIServerConfig from './aiServerConfig.directive';
import CheckDetectorConfig from './checkDetectorConfig.directive';
import HEYEConfig from './heyeConfig.directive';
import PLCConfig from './plcConfig.directive';
import ScaleConfig from './scaleConfig.directive';
import PPCScaleConfig from './ppcScaleConfig.directive';
import SerialConverterConfig from './serialConverterConfig.directive';
import WSIConfig from './wsiConfig.directive';
import RaspberryPiConfig from './raspberryPiConfig.directive';
import TiamaConfig from './tiamaConfig.directive';
import FlexInspectConfig from './flexInspectConfig.directive';
import LineServerConfig from './lineServerConfig.directive';
import FlexIsConfig from './flexIsConfig.directive';
import KepwareCounterConfig from './kepwareCounterConfig.directive';
import SqlCounterConfig from './sqlCounterConfig.directive';

let requires = [
  ScaleConfig,
  PLCConfig,
  HEYEConfig,
  SerialConverterConfig,
  WSIConfig,
  AIServerConfig,
  CheckDetectorConfig,
  RaspberryPiConfig,
  TiamaConfig,
  FlexInspectConfig,
  FlexIsConfig,
  LineServerConfig,
  KepwareCounterConfig,
  SqlCounterConfig,
  PPCScaleConfig
];

export default angular.module('aps.controller.configSelector', requires)
  .directive('apsConfigSelector', (): angular.IDirective => {
    return {
      restrict: 'E',
      template: template
    };
  })
  .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/equipment/configSelector.directive.ts